import { render } from "./FinalPayment.vue?vue&type=template&id=06b79996&scoped=true"
import script from "./FinalPayment.vue?vue&type=script&lang=js"
export * from "./FinalPayment.vue?vue&type=script&lang=js"

import "./FinalPayment.vue?vue&type=style&index=0&id=06b79996&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06b79996"]])

export default __exports__